import React from 'react';

export const Comments = ({ comments }) => {
  return (
    <div className="manifest-comments">
      <div className="title flex-row">Comments:</div>
      <div className="flex-row">{comments || ' '}</div>
    </div>
  );
};
